export default "__VITE_ASSET__DAfGD1Zm__"